module.exports = __webpack_public_path__ + "img/ni.dddc30c7.svg";